import { datetimeString } from '../../datetimeUtils';

export const RECEIVE_NOTIFICATION = 'dt/notification/RECEIVE_NOTIFICATION';
export const HIDE_NOTIFICATION = 'dt/notification/HIDE_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'dt/notification/REMOVE_NOTIFICATION';
export const REMOVE_NOTIFICATIONS_BY_TYPE = 'dt/notification/REMOVE_NOTIFICATIONS_BY_TYPE';
export const MARK_NOTIFICATIONS_READ = 'dt/notification/MARK_NOTIFICATIONS_READ';
export const CLEAR_ALL_NOTIFICATIONS = 'dt/notification/CLEAR_ALL_NOTIFICATIONS';
export const CLEAR_FILTERED_NOTIFICATIONS = 'dt/notification/CLEAR_FILTERED_NOTIFICATIONS';
export const SET_PANEL_OPENED = 'dt/notification/SET_PANEL_OPENED';
export const SET_NOTIFICATION_FILTERS = 'dt/notification/SET_NOTIFICATION_FILTERS';
export const RESET_NOTIFICATION_FILTERS = 'dt/notification/RESET_NOTIFICATION_FILTERS';
export const START_NOTIFICATION_TIMER = 'dt/notification/START_NOTIFICATION_TIMER';
export const CANCEL_NOTIFICATION_TIMER = 'dt/notification/CANCEL_NOTIFICATION_TIMER';
export const START_POLLING_ONLINE = 'dt/notification/START_POLLING_ONLINE';
export const STOP_POLLING_ONLINE = 'dt/notification/STOP_POLLING_ONLINE';
export const SET_ONLINE = 'dt/notification/SET_ONLINE';
export const SET_OFFLINE = 'dt/notification/SET_OFFLINE';
export const CHECK_ONLINE = 'dt/notification/CHECK_ONLINE';

export const TYPES = {
  transient: 0,
  persistent: 1,
  actionable: 2,
};

const crypto = globalThis.crypto || globalThis.msCrypto;
const array = new Uint32Array(1);

export const getTemporaryId = () => Date.now() + crypto.getRandomValues(array)[0] * 1000;

export function displayNotification(notification) {
  const now = new Date();
  const createdAt = now.getTime();
  const { id, type } = notification;
  const resolvedType = TYPES[type] || TYPES.transient;

  return {
    type: RECEIVE_NOTIFICATION,
    notification: {
      ...notification,
      id: id || getTemporaryId(),
      visible: true,
      type: resolvedType,
      category: notification.category || 'system',
      createdAt,
      extra:
        notification.extra ||
        (resolvedType === TYPES.persistent
          ? datetimeString(now, Intl.DateTimeFormat().resolvedOptions().timeZone)
          : undefined),
    },
  };
}

export function hideNotification(id) {
  return {
    type: HIDE_NOTIFICATION,
    id,
  };
}

export function removeNotification(id) {
  return {
    type: REMOVE_NOTIFICATION,
    id,
  };
}

export function startNotificationTimer(id, hideTimeout) {
  return {
    type: START_NOTIFICATION_TIMER,
    id,
    hideTimeout,
  };
}

export function cancelNotificationTimer() {
  return {
    type: CANCEL_NOTIFICATION_TIMER,
  };
}

export function removeNotificationsByType(notificationType) {
  return {
    type: REMOVE_NOTIFICATIONS_BY_TYPE,
    notificationType,
  };
}

export function markNotificationsRead() {
  return {
    type: MARK_NOTIFICATIONS_READ,
  };
}

export function startPollingOnline() {
  return {
    type: START_POLLING_ONLINE,
  };
}

export function stopPollingOnline() {
  return {
    type: STOP_POLLING_ONLINE,
  };
}

export function setOnline() {
  return {
    type: SET_ONLINE,
  };
}

export function setOffline() {
  return {
    type: SET_OFFLINE,
  };
}

export function checkIsOnline() {
  return {
    type: CHECK_ONLINE,
  };
}

export function clearAllNotifications() {
  return {
    type: CLEAR_ALL_NOTIFICATIONS,
  };
}

export function clearFilteredNotifications({ filters }) {
  return {
    type: CLEAR_FILTERED_NOTIFICATIONS,
    filters,
  };
}

export function setPanelOpened() {
  return {
    type: SET_PANEL_OPENED,
  };
}

export function setNotificationFilters(filters) {
  return {
    type: SET_NOTIFICATION_FILTERS,
    filters,
  };
}

export function resetNotificationFilters() {
  return {
    type: RESET_NOTIFICATION_FILTERS,
  };
}
